var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlutenFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gluten_free") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gluten_free",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 30,
    cx: 263,
    cy: 263,
    r: 235
  }), /*#__PURE__*/React.createElement("g", {
    id: "GF",
    transform: "translate(105.000000, 173.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8078859,194 C66.2122483,194 52.2546141,189.854701 39.9349832,181.564103 C27.6153523,173.273504 17.8796141,161.827873 10.7277685,147.227208 C3.57592282,132.626543 0,115.838082 0,96.8618234 C0,82.5835708 2.09941275,69.5258784 6.29823826,57.6887464 C10.4970638,45.8516144 16.4953859,35.6265432 24.2932047,27.0135328 C32.0910235,18.4005223 41.4114933,11.7450142 52.2546141,7.04700855 C63.0977349,2.34900285 75.1635906,0 88.4521812,0 C108.569631,0 124.949664,4.53679962 137.592282,13.6103989 C150.234899,22.6839981 159.232383,36.8931624 164.584732,56.2378917 L117.520973,64.6666667 C114.383389,57.0208927 110.230705,50.9871795 105.062919,46.5655271 C99.8951342,42.1438746 93.5276846,39.9330484 85.9605705,39.9330484 C78.7625839,39.9330484 72.2797819,42.2359924 66.5121644,46.8418803 C60.744547,51.4477683 56.1996644,57.9881292 52.8775168,66.462963 C49.5553691,74.9377968 47.8942953,85.0707502 47.8942953,96.8618234 C47.8942953,108.560779 49.5553691,118.670703 52.8775168,127.191595 C56.1996644,135.712488 60.744547,142.275878 66.5121644,146.881766 C72.2797819,151.487654 78.7625839,153.790598 85.9605705,153.790598 C93.0662752,153.790598 99.4106544,152.293685 104.993708,149.299858 C110.576762,146.30603 114.960151,142.252849 118.143876,137.140313 C121.327601,132.027778 122.919463,126.385565 122.919463,120.213675 L130.671141,120.213675 C130.671141,135.320988 128.871644,148.401709 125.272651,159.45584 C121.673658,170.509972 116.275168,179.030864 109.077181,185.018519 C101.879195,191.006173 92.7894295,194 81.8078859,194 Z M128.456376,189.578348 L122.919463,151.441595 L122.919463,118.555556 L85.9605705,118.279202 L85.9605705,91.1965812 L165,91.1965812 L165,189.578348 L128.456376,189.578348 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "195 189 195 4 316 4 316 42.185544 239.251429 42.185544 239.251429 78.4411326 307.979429 78.4411326 307.979429 116.075261 239.251429 116.075261 239.251429 189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFree);
export default __webpack_public_path__ + "static/media/gluten_free.b5a41dcfacf1f0d32bad836079234b46.svg";
export { ForwardRef as ReactComponent };